const LINE_INFO_LIGHTBOX_SELECTOR = 'zoom-dialog.pdp-line-info-lightbox';
const LINE_INFO_LIGHTBOX_TRIGGER_SELECTOR = '[data-pdp-line-info-lightbox-target]';
const LINE_INFO_LIGHTBOX_INDEX_SELECTOR = '[data-pdp-line-info-lightbox-index]';

function getSelectedIndex(trigger) {
  const index = Number(trigger.getAttribute('data-pdp-line-info-lightbox-index'));

  return Number.isInteger(index) && index >= 0 ? index : null;
}

function setSelectedState(lightbox, index) {
  const stateButtons = lightbox.querySelectorAll('.pdp-line-info-lightbox__state button');

  stateButtons.forEach((button, buttonIndex) => {
    button.setAttribute('aria-selected', `${buttonIndex === index}`);
  });
}

function syncLightbox(lightbox, index) {
  if (!lightbox || index === null) return;

  setSelectedState(lightbox, index);
}

function syncLightboxAfterLayout(lightbox, index) {
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => syncLightbox(lightbox, index));
  });
}

document.addEventListener('click', (event) => {
  const clickTarget = event.target;

  if (!(clickTarget instanceof Element)) return;

  const opener = clickTarget.closest(LINE_INFO_LIGHTBOX_TRIGGER_SELECTOR);
  const indexedTrigger = clickTarget.closest(LINE_INFO_LIGHTBOX_INDEX_SELECTOR);
  const trigger = opener || indexedTrigger;

  if (!trigger) return;

  const index = getSelectedIndex(trigger);
  const lightbox = opener
    ? document.getElementById(opener.getAttribute('data-pdp-line-info-lightbox-target'))
    : indexedTrigger.closest(LINE_INFO_LIGHTBOX_SELECTOR);

  syncLightboxAfterLayout(lightbox, index);
});

document.addEventListener('zoom-media:selected', (event) => {
  const eventTarget = event.target;

  if (!(eventTarget instanceof Element)) return;

  const lightbox = eventTarget.closest(LINE_INFO_LIGHTBOX_SELECTOR);
  const index = event.detail?.index;

  syncLightboxAfterLayout(lightbox, Number.isInteger(index) ? index : null);
});
